import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetCareNowFormatService } from '../../../get-care-now-feature/utilities/getcarenow-format.service';
import { TranslateService } from '@ngx-translate/core';
import { MonitoringService } from '../../../shared/services/monitoring/monitoring-service';
import { SearchStateService } from '../../shared/services/search-state.service';
import { MCAppGatewayService } from '../../../shared/services/mcappgateway/mcappgateway.service';
import { PostGetProviderDetailsRequest } from '../../../shared/model/providerlocationsearch/PostGetProviderDetailRequest';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-provider-search-results-card',
  imports: [CommonModule],
  templateUrl: './provider-search-results-card.component.html',
  styleUrl: './provider-search-results-card.component.css'
})
export class ProviderSearchResultsCardComponent {
  @Input() provider!: any
  @Input() currentLocation: any = null;
  @Input() queryCityOrZip!: any;

  public eptID: any = null;

  public soonAsText: string = 'AS_SOON_AS';
  public milesAwayText: string = 'DESCRIPTION';
  public scheduleText: string = 'SCHEULE';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';
  public noAvailabilityStr: string = 'NO_AVAILABILITY';  
  public waitTime: string = '';

  mcAppGateway = inject(MCAppGatewayService);
  searchState = inject(SearchStateService);

  private getCareNowFormatService: GetCareNowFormatService;

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem('locale') || 'en-US'); // Default to 'en-US' if no locale is provided
    this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
  }

  ngOnInit(): void {
  
      this.waitTime = this.getCareNowFormatService.formatNextAvailability(this.provider.nextAvailability);
  
      this.translate.get('BOOK_AS_SOON_AS').subscribe((translated: string) => {
        this.soonAsText = translated;
      });
  
      this.translate.get('MILES_AWAY').subscribe((translated: string) => {
        this.milesAwayText = translated;
      });
  
      this.translate.get('SCHEDULE').subscribe((translated: string) => {
        this.scheduleText = translated;
      });

      this.translate.get('VIEW_PROFILE').subscribe((translated: string) => {
        this.noAvailabilityStr = translated;
      });
  }

  scheduleAuth() {
    var deepLink = environment.web_scheduling_deep_link_base_url;
    deepLink += "?workflow=NewProvider"
 
    deepLink += "&selProvId=" + this.provider.providerEmrId;
    // deepLink += "&selRfvId=" + environment.office_visit_prc_id;
     
    if (this.provider.departmentId != null && this.provider.departmentId != '') {
      deepLink += "&selDepId=" + this.provider.departmentId;
    }
 
    if (this.provider.specialtyId != null && this.provider.specialtyId != '') {
      deepLink += "&selSpecialtyId=" + this.provider.specialtyId;
    }

    var searchMethod = sessionStorage.getItem('providerSearchMethod') ?? '';

    if (searchMethod.length > 0) {
      if (searchMethod === 'freeText') {
        deepLink += "&linksource=AUTHHMPLFRSPC";
      }
      else if (searchMethod === 'quickSearch') {
        deepLink += "&linksource=AUTHHMPLQSPC";
      }
    }

    this.monitoringService.logEvent('Schedule', { feature: 'search', subfeature: 'provider-search', platform: 'web'}); // log as mobile or web event

    window.location.href = deepLink;
  }

  scheduleUnauth() {
    var deepLink = environment.web_open_scheduling_deep_link_base_url;

    deepLink += "/standalone"; // Use standalone workflow for unauthenticated users)

    deepLink += "?id=" + this.provider.providerEmrId;
    // deepLink += "&vt=" + environment.office_visit_prc_id;

    if (this.provider.departmentId != null && this.provider.departmentId != '') {
      deepLink += "&dept=" + this.provider.departmentId;
    }
 
    if (this.provider.specialtyId != null && this.provider.specialtyId != '') {
      deepLink += "&specialty=" + this.provider.specialtyId;
    }

    var searchMethod = sessionStorage.getItem('providerSearchMethod') ?? '';

    if (searchMethod.length > 0) {
      if (searchMethod === 'freeText') {
        deepLink += "&linksource=PLUAFPLOXFTPROV";
      }
      else if (searchMethod === 'quickSearch') {
        deepLink += "&linksource=PLUAFPLOCQSPROV";
      }
    }

    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'search-care-now', subfeature: 'provider', platform: 'web'}); // log as mobile or web event
      
    window.location.href = deepLink;
  }
  
  onScheduleButtonClicked() {
    if (this.provider && this.provider.providerEmrId && this.provider.providerEmrId.length > 0) {
      const eptID = sessionStorage.getItem("eptID");
      if (eptID != null && eptID != '') {
        this.scheduleAuth();
      }
      else {
        this.scheduleUnauth();
      }
    }
  }

  viewProviderDetails() {
    console.log('Viewing details for provider:', this.provider);

    window.scrollTo({ top: 50, behavior: 'smooth' });

    this.searchState.setCurrentProviderDetails(this.provider);
    this.searchState.setShowSpinner(true);

    var providerDetailsRequest = new PostGetProviderDetailsRequest();
    providerDetailsRequest.providerID = this.provider.providerId;
    providerDetailsRequest.cityOrZip = this.queryCityOrZip;
    providerDetailsRequest.latitude = this.currentLocation?.latitude || null;
    providerDetailsRequest.longitude = this.currentLocation?.longitude || null;   

    this.mcAppGateway.PostGetProviderDetails(providerDetailsRequest).subscribe({
      next: (response) => {
        console.log('Provider Details Response:', response);
        
        // Handle the response as needed
        this.searchState.setCurrentProviderDetails(response);
        this.searchState.setShowSpinner(false);
      },
      error: (error) => {
        console.error('Error fetching provider details:', error);
        alert('An error occurred while fetching provider details. Please try again later.');
        this.searchState.setShowSpinner(false);
        this.searchState.clearCurrentProviderDetails();
      }
    });
  }

  onGetDirections() {
    if (this.provider && this.provider.address1 && this.provider.city && this.provider.zip) {
      
      // Construct the full address
      const destination = `${this.provider.address1}, ${this.provider.city}, CA ${this.provider.zip}`;
      const encodedDestination = encodeURIComponent(destination);
      const mapsUrl = environment.web_google_map + encodedDestination;
      
      window.open(mapsUrl, '_blank');
    }
  }
}
